export default "__VITE_ASSET__C2g4jOCG__"